import { render, staticRenderFns } from "./ArrearsPostingLog.vue?vue&type=template&id=78081f36"
import script from "./ArrearsPostingLog.vue?vue&type=script&lang=js"
export * from "./ArrearsPostingLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports